// src/Scenes/NewQuotation/components
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
// < DatePicker
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
// DatePicker />

import { Button } from '@material-ui/core';

import PdfViewerComponent from './PdfViewerComponent';

import { extractDefaultPdfFromOptions, extractPdfFromSelectedOption, getReducedWindowDimensions } from './utils';
import './ProductExplorerComponent.scss'; // Add your custom styles if needed


const ProductExplorerComponent = ({
  widgetTitle,
  widgetSubTitle,
  selectedDate,
  selectedOption, // commercialProduct
  strings,
  productPlaceholder,
  dateFormat,
  options = [],
  handleDateChange,
  handleSelectChange,
  handleButtonClick,
  iframeWidth,
  iframeHeight,
}) => {
  const [value, setValue] = useState(selectedOption);
  const [pdfUrl, setPdfUrl] = useState(undefined);
  const [complementaryPdfUrl, setComplementaryPdfUrl] = useState(undefined);
  const [complementaryHeight, setComplementaryHeight] = useState(iframeHeight);
  const [complementaryWidth, setComplementaryWidth] = useState(iframeWidth);
  const [windowDimensions, setWindowDimensions] = useState(
    getReducedWindowDimensions({ minusHeight: 150, minusWidth: 255, id: 'step-product-list', url: pdfUrl }) || { widthPx: complementaryWidth, heightPx: complementaryHeight },
  );

  const locationOrigin = window.location.origin;

  const handleResize = () => {
    const reducedWindowDimensions = getReducedWindowDimensions({ minusHeight: 150, minusWidth: 200, id: 'step-product-list', url: pdfUrl });
    if (reducedWindowDimensions) {
      setWindowDimensions(reducedWindowDimensions);
    }
  }

  useEffect(() => {
    setPdfUrl(extractDefaultPdfFromOptions({ options, origin: locationOrigin }));
  }, [options, selectedOption]);

  useEffect(() => {
    setComplementaryHeight(selectedOption?.attachments?.[1]?.height ?? iframeHeight);
  }, [iframeHeight, selectedOption]);

  useEffect(() => {
    setComplementaryWidth(selectedOption?.attachments?.[1]?.width ?? iframeHeight);
  }, [iframeWidth, selectedOption]);

  useEffect(() => {
    setComplementaryPdfUrl(extractPdfFromSelectedOption({ selectedOption, origin: locationOrigin }));
  }, [selectedOption]);

  useEffect(() => {
    setValue(selectedOption);
  }, [selectedOption]);

  useEffect(() => {
    const reducedWindowDimensions = getReducedWindowDimensions({ minusHeight: 150, minusWidth: 255, id: 'step-product-list', url: pdfUrl });
    if (reducedWindowDimensions?.height !== windowDimensions?.height) {
      setTimeout(
        handleResize(), 2000);
    }
    // register
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <h2>{widgetTitle}</h2>
      <p>{widgetSubTitle}</p>
      <div className="product-select-component">
        <div className="date-picker-container">
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="Sélectionnez une date"
            locale="fr"
          />
        </div>
        <div className="select-container">
          <Select
            isClearable={true}
            value={value}
            onChange={handleSelectChange}
            options={options}
            placeholder={productPlaceholder ?? 'Select a product...'}
            formatOptionLabel={(option) => (
              <div className="option-label">
                {option.label}
              </div>
            )}
          />
        </div>
        <div className="button-container">
          <Button variant="contained" type="submit" color="primary" onClick={handleButtonClick}>
            {strings['button.label.start'] || 'Commencer'}
          </Button>
        </div>
      </div>
      {complementaryPdfUrl ?
        <PdfViewerComponent
          id="PdfViewerComponentComplementary"
          pdfUrl={complementaryPdfUrl}
          method="pdfjs-mozilla"
          iframeWidth={windowDimensions.widthPx}
          iframeHeight={windowDimensions.heightPx}
          className="complementaryPdfUrl-style"
        /> :
        pdfUrl && <PdfViewerComponent
          id="PdfViewerComponentPrimary"
          pdfUrl={pdfUrl}
          method="pdfjs-mozilla"
          iframeWidth={windowDimensions.widthPx}
          iframeHeight={windowDimensions.heightPx}
          className="pdfUrl-style"
        />
      }
    </>
  );
};


ProductExplorerComponent.prototype = {
  options: PropTypes.object,
  strings: PropTypes.objectOf(PropTypes.string),
  handleFetchProducts: PropTypes.func,
  handleSelectProduct: PropTypes.func,
}

ProductExplorerComponent.defaultProps = {
  options: [],
  strings: {},
  handleFetchProducts: params => console.log('handleFetchProducts ::', params),
  handleSelectProduct: params => console.log('handleSelectProduct ::', params),
  handleDateChange: params => console.log('ProductExplorerComponent:handleFetchProducts ::', params),
  handleSelectChange: params => console.log('ProductExplorerComponent:handleSelectChange ::', params),
  handleButtonClick: params => console.log('ProductExplorerComponent:handleButtonClick ::', params),
};

export default ProductExplorerComponent;
